import { clsx } from 'clsx';
import React, { PropsWithChildren } from 'react';
import Text from '~/components/typographies/Text';
import styles from './TableLabels.module.scss';

interface MainLabelProps {
  error?: boolean;
  success?: boolean;
  tabularNums?: boolean;
  className?: string;
  align?: 'left' | 'center' | 'right';
}

export const MainLabel: React.FC<PropsWithChildren<MainLabelProps>> = ({
  children,
  error,
  className,
  align = 'left',
  success,
  tabularNums,
}) => (
  <Text
    variant="body2"
    weight="semibold"
    align={align}
    tabularNums={tabularNums}
    className={clsx(styles.mainLabel, { [styles.error!]: error, [styles.success!]: success }, className)}
  >
    {children}
  </Text>
);

interface SecondaryLabelProps {
  className?: string;
  tabularNums?: boolean;
}

export const SecondaryLabel: React.FC<PropsWithChildren<SecondaryLabelProps>> = ({
  children,
  tabularNums,
  className,
}) => (
  <Text
    variant="caption"
    weight="medium"
    className={clsx(styles.secondaryLabel, className)}
    secondaryColor
    tabularNums={tabularNums}
  >
    {children}
  </Text>
);
